import { cn } from "@/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn("size-8", className)}
      role="img"
      aria-label="Rocketeer Orbit"
    >
      <defs>
        <linearGradient id="ro-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="currentColor" stopOpacity="0.95" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.6" />
        </linearGradient>
      </defs>
      <ellipse
        cx="16"
        cy="17"
        rx="12"
        ry="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        opacity="0.4"
        transform="rotate(-20 16 17)"
      />
      <path
        d="M16 4.5c3.5 2.9 5.3 6.6 5.3 10.6 0 2.5-.7 4.8-1.9 6.6h-6.8c-1.2-1.8-1.9-4.1-1.9-6.6 0-4 1.8-7.7 5.3-10.6Z"
        fill="url(#ro-mark)"
      />
      <circle cx="16" cy="12.6" r="1.9" className="fill-background" />
      <path d="M13.9 23.2h4.2L16 28.4l-2.1-5.2Z" fill="var(--xp)" />
    </svg>
  );
}

export function Logo({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark className="size-8 text-brand" />
      {showWordmark && (
        <span className="flex flex-col leading-none">
          <span className="text-[15px] font-semibold tracking-tight">Rocketeer</span>
          <span className="text-[11px] font-medium tracking-[0.18em] text-muted-foreground uppercase">
            Orbit
          </span>
        </span>
      )}
    </span>
  );
}
